<template>
  <ul :class="['content-list', getStyleType, getSize, getAling]" :style="getColor">
    <slot/>
  </ul>
</template>

<script>
export default {
  name: 'content-list',
  props: {
    type: {
      type: String,
      default: 'disc'
    },
    color: {
      type: String,
      default: 'white'
    },
    align: {
      type: String,
      default: 'left'
    },
    size: {
      type: String,
      default: 'small'
    }
  },
  computed: {
    getStyleType() {
      return `content-list--${this.type}`
    },
    getSize() {
      return `content-list--${this.size}`
    },
    getColor() {
      return `color: ${this.color}`
    },
    getAling() {
      return `content-list--${this.align}`
    }
  }
}
</script>

<style lang="scss" scoped>

  $base-font-xs: 1.000em; // 16
  $base-font-sm: 1.125em; // 20
  $base-font-df: 1.250em; // 22
  $base-font-md: 1.375em; // 24
  $base-font-lg: 1.500em; // 26
  $base-font-xl: 1.625em; // 28
  $base-font-xxl: 1.750em; // 30
  
  .content-list {
    display: flex;
    flex-direction: column;
    color: #FFF;
    padding-left: 20px;
    list-style-position: outside;

    & > * {
      padding-left: 10px;
      list-style-image: none;
    }

    // Sizes

    &--extrasmall {
      font-size: $base-font-xs;
    }

    &--small {
      font-size: $base-font-sm
    }

    &--default {
      font-size: $base-font-df
    }

    &--medium {
      font-size: $base-font-md
    }

    &--large {
      font-size: $base-font-lg
    }

    &--extralarge {
      font-size: $base-font-xl
    }

    &--xxlarge {
      font-size: $base-font-xxl
    }

    &--center {
      align-items: center;
    }

    // List Styles

    &--disc {
      & li {
        list-style-type: disc;
      }
    }

    &--circle {
      & li {
        list-style-type: circle;
      }
    }

    &--decimal {
      & li {
        list-style-type: decimal;
      }
    }
  }
</style>